import { render, staticRenderFns } from "./SaveConfirm.pug?vue&type=template&id=1986864e&lang=pug&"
import script from "./SaveConfirm.vue?vue&type=script&lang=js&"
export * from "./SaveConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports